import { render, staticRenderFns } from "./AutomatorPointsList.vue?vue&type=template&id=4b858ef2&scoped=true"
import script from "./AutomatorPointsList.vue?vue&type=script&lang=js"
export * from "./AutomatorPointsList.vue?vue&type=script&lang=js"
import style0 from "./AutomatorPointsList.vue?vue&type=style&index=0&id=4b858ef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b858ef2",
  null
  
)

export default component.exports